import { shape, string, number, oneOfType } from 'prop-types';
export const merchant = shape({
  selectedMerchant: shape({
    merchantId: oneOfType([string, number]),
    name: string,
  }),
});
